import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import axios from "axios";
import Cookies from "js-cookie";
import { getUserRole } from "./components/admin/userRoles";

Vue.use(Router);
let router = new Router({
  mode: "history",
  scrollBehavior(to, from, saved) {
    return saved || { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/appSidebar",
      props: true,
      component: () => import("./components/Common/appSidebar"),
      meta: {
        requireAuth: true,
      },
      children: [
        {
          path: "/DashboardPage",
          name: "DashboardPage",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { role: "admin" },
          component: () => import("./components/Common/RoleDashboard.vue"),
        },
        {
          path: "/NatureCamps",
          name: "NatureCamps",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/NatureCamps.vue"),
        },



        {
          path: "/CampDetailedView",
          name: "CampDetailedView",
          meta: {
            requireAuth: true, roles: ['user', 'clerk', 'superint', 'division', 'admin', 'dcf']
          },
          component: () => import("./components/user/CampDetailedView.vue"),
        },
        {
          path: "/help",
          name: "help",
          meta: {
            requireAuth: true, roles: ['clerk', 'superint', 'adminclerk', 'adminsuperint', 'dcf', 'admin']
          },
          component: () => import("./components/Common/HelpPage.vue"),
        },
        {
          path: "/profilepage",
          name: "profilepage",
          meta: {
            requireAuth: true, roles: ['user', 'clerk', 'superint', 'division', 'adminclerk', 'adminsuperint', 'dcf', 'admin']
          },
          component: () => import("./components/Common/profilePage.vue"),
        },
        {
          path: "/editbooking",
          name: "editbooking",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/EditMyBookings.vue"),
        },
        {
          path: "/EditForwardApplication",
          name: "EditForwardApplication",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/EditForwardApplication.vue"),
        },
        {
          path: "/sectionclerk",
          name: "sectionclerk",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { staffType: "clerk" },
          component: () => import("./components/Common/StaffManagement.vue"),
        },
        {
          path: "/AddClerk",
          name: "AddClerk",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { staffType: "adminClerk" },
          component: () => import("./components/Common/StaffManagement.vue"),
        },
        {
          path: "/CancelledApplicationAdmin",
          name: "CancelledApplicationAdmin",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { listType: "cancelled" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/completed-payments",
          name: "CompletedPayments",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          component: () => import("./components/completedpayments/completedpayments.vue"),
        },
        {
          path: "/payment-log",
          name: "PaymentLog",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          component: () => import("./components/completedpayments/PaymentLog.vue"),
        },
        {
          path: "/AddSuperint",
          name: "AddSuperint",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { staffType: "ministerial" },
          component: () => import("./components/Common/StaffManagement.vue"),
        },
        {
          path: "/AddSuperAdmin",
          name: "AddSuperAdmin",
          meta: {
            requireAuth: true, roles: ['superadmin']
          },
          props: { staffType: "superadmin" },
          component: () => import("./components/Common/StaffManagement.vue"),
        },
        {
          path: "/AddDcf",
          name: "AddDcf",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { staffType: "dcf" },
          component: () => import("./components/Common/StaffManagement.vue"),
        },
        {
          path: "/superintedent",
          name: "superintedent",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { staffType: "superintendent" },
          component: () => import("./components/Common/StaffManagement.vue"),
        },
        {
          path: "/SuperintedentHome",
          name: "SuperintedentHome",
          meta: {
            requireAuth: true, roles: ['superint']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/SuperintedentDashboard",
          name: "SuperintedentDashboard",
          meta: {
            requireAuth: true, roles: ['superint']
          },
          props: { role: "superint" },
          component: () => import("./components/Common/RoleDashboard.vue"),
        },
        {
          path: "/CancelledApplicationSuperintedent",
          name: "CancelledApplicationSuperintedent",
          meta: {
            requireAuth: true, roles: ['superint']
          },
          props: { listType: "cancelled" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AllApplicationsSuperint",
          name: "AllApplicationsSuperint",
          meta: {
            requireAuth: true, roles: ['superint']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AdminClerk",
          name: "AdminClerk",
          meta: {
            requireAuth: true, roles: ['adminclerk']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/cwwclerkdashboard",
          name: "cwwclerkdashboard",
          meta: {
            requireAuth: true, roles: ['adminclerk']
          },
          props: { role: "adminclerk" },
          component: () => import("./components/Common/RoleDashboard.vue"),
        },
        {
          path: "/AllApplicationsCwwclerk",
          name: "AllApplicationsCwwclerk",
          meta: {
            requireAuth: true, roles: ['adminclerk']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ApprovedApplicationsCwwclerk",
          name: "ApprovedApplicationsCwwclerk",
          meta: {
            requireAuth: true, roles: ['adminclerk']
          },
          props: { listType: "approved" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/CancelledApplicationCwwclerk",
          name: "CancelledApplicationCwwclerk",
          meta: {
            requireAuth: true, roles: ['adminclerk']
          },
          props: { listType: "cancelled" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AdminMinisterialhead",
          name: "AdminMinisterialhead",
          meta: {
            requireAuth: true, roles: ['adminsuperint']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AllApplicationsCwwministerial",
          name: "AllApplicationsCwwministerial",
          meta: {
            requireAuth: true, roles: ['adminsuperint']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ApprovedApplicationsCwwministerial",
          name: "ApprovedApplicationsCwwministerial",
          meta: {
            requireAuth: true, roles: ['adminsuperint']
          },
          props: { listType: "approved" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/CancelledApplicationCwwministerial",
          name: "CancelledApplicationCwwministerial",
          meta: {
            requireAuth: true, roles: ['adminsuperint']
          },
          props: { listType: "cancelled" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ClerkHome",
          name: "ClerkHome",
          meta: {
            requireAuth: true, roles: ['clerk']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AllApplicationsClerk",
          name: "AllApplicationsClerk",
          meta: {
            requireAuth: true, roles: ['clerk']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ApprovedApplicationsClerk",
          name: "ApprovedApplicationsClerk",
          meta: {
            requireAuth: true, roles: ['clerk']
          },
          props: { listType: "approved" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ClerkDashboard",
          name: "ClerkDashboard",
          meta: {
            requireAuth: true, roles: ['clerk']
          },
          props: { role: "clerk" },
          component: () => import("./components/Common/RoleDashboard.vue"),
        },

        {
          path: "/Cwwministerial",
          name: "Cwwministerial",
          meta: {
            requireAuth: true, roles: ['adminsuperint']
          },
          props: { mode: "adminsuperint" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/CwwministerialDashboard",
          name: "CwwministerialDashboard",
          meta: {
            requireAuth: true, roles: ['adminsuperint']
          },
          props: { role: "adminsuperint" },
          component: () => import("./components/Common/RoleDashboard.vue"),
        },
        {
          path: "/DcfDashboard",
          name: "DcfDashboard",
          meta: {
            requireAuth: true, roles: ['dcf']
          },
          props: { role: "dcf" },
          component: () => import("./components/Common/RoleDashboard.vue"),
        },
        {
          path: "/DcfPending",
          name: "DcfPending",
          meta: {
            requireAuth: true, roles: ['dcf']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AllApplicationsDcf",
          name: "AllApplicationsDcf",
          meta: {
            requireAuth: true, roles: ['dcf']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ApprovedApplicationsDcf",
          name: "ApprovedApplicationsDcf",
          meta: {
            requireAuth: true, roles: ['dcf']
          },
          props: { listType: "approved" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/DcfApplication",
          name: "DcfApplication",
          meta: {
            requireAuth: true, roles: ['dcf']
          },
          props: { mode: "dcf" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/CancelRequestDcf",
          name: "CancelRequestDcf",
          meta: {
            requireAuth: true, roles: ['dcf']
          },
          props: { listType: "cancelRequests" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/CancelledApplicationDcf",
          name: "CancelledApplicationDcf",
          meta: {
            requireAuth: true, roles: ['dcf']
          },
          props: { listType: "cancelled" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },

        {
          path: "/NatureCampDetails",
          name: "NatureCampDetails",
          meta: {
            requireAuth: true, roles: ['user', 'clerk', 'superint', 'division', 'admin', 'adminclerk', 'adminsuperint', 'dcf']
          },
          component: () => import("./components/user/NatureCampDetails.vue"),
        },
        {
          path: "/ApplicantDetails",
          name: "ApplicantDetails",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/ApplicantDetails.vue"),
        },
        {
          path: "/cancelledapplications",
          name: "cancelledapplications",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/CancelledApplications.vue"),
        },




        {
          path: "/DraftApplications",
          name: "DraftApplications",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/DraftApplications.vue"),
        },
        {
          path: "/SubmittedApplications",
          name: "SubmittedApplications",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/SubmittedApplications.vue"),
        },
        {
          path: "/CancellationRequests",
          name: "CancellationRequests",
          meta: {
            requireAuth: true, roles: ['user']
          },
          props: { cancelRequests: true },
          component: () => import("./components/user/SubmittedApplications.vue"),
        },
        {
          path: "/ApprovedApplicationsUser",
          name: "ApprovedApplicationsUser",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/ApprovedApplications.vue"),
        },

        {
          path: "/mybooking",
          name: "mybooking",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/MyBooking.vue"),
        },

        {
          path: "/ForwardedApplications",
          name: "ForwardedApplications",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/ForwardedApplications.vue"),
        },

        {
          path: "/booknow",
          name: "booknow",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/BookNatureCamp.vue"),
        },
        {
          path: "/userviewstatus",
          name: "userviewstatus",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/user/UserviewStatus.vue"),
        },
        {
          path: "/paywaitscreen",
          name: "paywaitscreen",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/Payment/PayWaitScreen.vue"),
        },
        {
          path: "/SuccessPage",
          name: "SuccessPage",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/Payment/SuccessPage.vue"),
        },
        {
          path: "/FailurePage",
          name: "FailurePage",
          meta: {
            requireAuth: true, roles: ['user']
          },
          component: () => import("./components/Payment/FailurePage.vue"),
        },
        {
          path: "/cancelled",
          name: "cancelled",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          component: () => import("./components/admin/CanclledBooking.vue"),
        },
        {
          path: "/tomorrow",
          name: "tomorrow",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          component: () => import("./components/admin/BookinsTomorrow.vue"),
        },
        {
          path: "/PendingApplicationsAdmin",
          name: "PendingApplicationsAdmin",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AdminBookinsPage",
          name: "AdminBookinsPage",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/NamudekeralamApplications",
          name: "NamudekeralamApplications",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { listType: "namudekeralam" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },

        {
          path: "/CampDetailedViewAdmin",
          name: "CampDetailedViewAdmin",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { mode: "adminReview" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/records",
          name: "records",
          meta: {
            requireAuth: true, roles: ['user', 'admin', 'clerk', 'superint', 'division', 'adminsuperint', 'adminclerk', 'dcf']
          },
          component: () => import("./components/user/RecordsPage.vue"),
        },
        {
          path: "/recordspage",
          name: "recordspage",
          meta: {
            requireAuth: true, roles: ['user', 'admin', 'clerk', 'superint', 'division', 'adminsuperint', 'adminclerk', 'dcf']
          },
          component: () => import("./components/user/RecordsPage.vue"),
        },
        {
          path: "/view",
          name: "view",
          meta: {
            requireAuth: true,
          },
          component: () => import("./components/admin/BookingDetailedview.vue"),
        },
        {
          path: "/divisionNatureCamp",
          name: "divisionNatureCamp",
          meta: {
            requireAuth: true, roles: ['division', 'clerk']
          },
          component: () => import("./components/Common/CampManagement.vue"),
        },
        {
          path: "/ViewReservations",
          name: "ViewReservations",
          meta: {
            requireAuth: true,
          },
          component: () => import("./components/division/ViewReservations.vue"),
        },
        {
          path: "/CancelledApplicationDivision",
          name: "CancelledApplicationDivision",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { listType: "cancelled" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },

        {
          path: "/bookib",
          name: "bookib",
          meta: {
            requireAuth: true,
          },
          component: () => import("./components/division/IbBook.vue"),
        },

        {
          path: "/ApprovedApplicationsAdmin",
          name: "ApprovedAppsAdmin",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { listType: "approved" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ApprovedApplications",
          name: "ApprovedApplications",
          meta: {
            requireAuth: true, roles: ['admin', 'division']
          },
          props: { listType: "approved" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/DivisionMybooking",
          name: "DivisionMybooking",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },

        {
          path: "/ApplicationDivision",
          name: "ApplicationDivision",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/CancelRequest",
          name: "CancelRequest",
          meta: {
            requireAuth: true, roles: ['division', 'clerk']
          },
          props: { listType: "cancelRequests" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/PendingApplicationDivision",
          name: "PendingApplicationDivision",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { listType: "pending" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/ApplicationSuperintedent",
          name: "ApplicationSuperintedent",
          meta: {
            requireAuth: true, roles: ['superint']
          },
          props: { listType: "approved" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/AllApplicationsSuperint",
          name: "AllApplicationsSuperint",
          meta: {
            requireAuth: true, roles: ['superint']
          },
          props: { listType: "all" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/CampDetailedViewDivision",
          name: "CampDetailedViewDivision",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { mode: "divisionReview" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/DivisionCancelView",
          name: "DivisionCancelView",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { mode: "cancelReview" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/CampDetailedDivision",
          name: "CampDetailedDivision",
          meta: {
            requireAuth: true, roles: ['superint', 'division', 'admin']
          },
          props: { mode: "readOnly" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/blockdate",
          name: "blockdate",
          meta: {
            requireAuth: true,
          },
          component: () => import("./components/division/BlockDate.vue"),
        },
        {
          path: "/CampDetailedAdmin",
          name: "CampDetailedAdmin",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          props: { mode: "adminView" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/CancelRequestClerk",
          name: "CancelRequestClerk",
          meta: {
            requireAuth: true, roles: ['clerk']
          },
          props: { listType: "cancelRequests" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/CancelledApplicationClerk",
          name: "CancelledApplicationClerk",
          meta: {
            requireAuth: true, roles: ['clerk']
          },
          props: { listType: "cancelled" },
          component: () => import("./components/Common/ApplicationList.vue"),
        },
        {
          path: "/CampDetailedViewClerk",
          name: "CampDetailedViewClerk",
          meta: {
            requireAuth: true, roles: ['clerk']
          },
          props: { mode: "clerk" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/Adminclerkview",
          name: "Adminclerkview",
          meta: {
            requireAuth: true, roles: ['adminclerk']
          },
          props: { mode: "adminclerk" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },
        {
          path: "/CampDetailedViewSuperint",
          name: "CampDetailedViewSuperint",
          meta: {
            requireAuth: true, roles: ['superint']
          },
          props: { mode: "superint" },
          component: () => import("./components/Common/ApplicationDetail.vue"),
        },


        {
          path: "/report",
          name: "report",
          meta: {
            requireAuth: true,
          },
          component: () => import("./components/division/Report.vue"),
        },

        {
          path: "/divisiondashboard",
          name: "divisiondashboard",
          meta: {
            requireAuth: true, roles: ['division']
          },
          props: { role: "division" },
          component: () => import("./components/Common/RoleDashboard.vue"),
        },

        {
          path: "/CancelledBookings",
          name: "CancelledBookings",
          meta: {
            requireAuth: true, roles: ['division']
          },
          component: () => import("./components/division/CancelledBookings.vue"),
        },
        {
          path: "/BookingTomorrow",
          name: "BookingTomorrow",
          meta: {
            requireAuth: true, roles: ['division']
          },
          component: () => import("./components/division/BookingTomorrow.vue"),
        },

        {
          path: "/adminnaturecamp",
          name: "adminnaturecamp",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          component: () => import("./components/Common/CampManagement.vue"),
        },

        {
          path: "/addcamp",
          name: "addcamp",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          component: () => import("./components/admin/AddNatureCamp.vue"),
        },

        {
          path: "/division-code",
          name: "division-code",
          meta: {
            requireAuth: true, roles: ['admin']
          },
          component: () => import("./components/admin/divisioncode.vue"),
        },
        {
          path: "/division-code-details",
          name: "division-code-details",
          meta: {
            requireAuth: true, roles: ['division']
          },
          component: () => import("./components/division/DivisionCodeView.vue"),
        },
        {
          path: "/admin-users-list",
          name: "SuperAdminUsersList",
          meta: {
            requireAuth: true, roles: ['superadmin']
          },
          component: () => import("./components/admin/SuperAdminUsersList.vue"),
        },
        {
          path: "/users/:role",
          name: "SuperAdminRoleUsers",
          meta: {
            requireAuth: true, roles: ['superadmin']
          },
          props: (route) => ({ role: route.params.role }),
          beforeEnter: (to, from, next) => {
            if (getUserRole(to.params.role)) next();
            else next({ name: "SuperAdminUsersList" });
          },
          component: () => import("./components/admin/SuperAdminUsersList.vue"),
        },
        {
          path: "/held-draft-applications",
          name: "HeldDraftApplications",
          meta: {
            requireAuth: true, roles: ['superadmin']
          },
          component: () => import("./components/admin/HeldDraftApplications.vue"),
        },

        {
          path: "/editib",
          name: "editib",
          meta: {
            requireAuth: true, roles: ['admin', 'division']
          },
          component: () => import("./components/admin/EditIb.vue"),
        },
        {
          path: "/test",
          name: "test",


          component: () => import("./components/TestPage"),
        },
      ],
    },
    {
      path: "/",
      name: "LandingPage",
      meta: {
        requireAuth: false,
      },
      component: () => import("./components/LandingPage.vue"),
    },
    {
      path: "/how-to-apply",
      name: "HowToApply",
      meta: {
        requireAuth: false,
      },
      component: () => import("./components/HowToApply.vue"),
    },
    {
      path: "/login",
      name: "LoginPage",
      meta: {
        requireAuth: false,
      },
      component: () => import("./components/Login/LoginPage"),
    },
    {
      path: "/register",
      name: "register",
      meta: {
        requireAuth: false,
      },
      component: () => import("./components/Login/RegisterPage"),
    },
    {
      path: "/verify",
      name: "verify",
      meta: {
        requireAuth: false,
      },
      component: () => import("./components/Login/oneTimepass"),
    },
    {
      path: "/forgotpassword",
      name: "forgotpassword",
      meta: {
        requireAuth: false,
      },
      component: () => import("./components/Login/ForgotPassword"),
    },
    {
      path: '/OtpPage',
      name: 'OtpPage',
      meta: {
        requireAuth: false,
      },
      component: function () {
        return import(/* webpackChunkName: "about" */ './components/Login/OtpPage.vue')
      }
    },
    // {
    //     path: '/',
    //     props: true,
    //     name: 'AdminDashboard',
    //     component: () =>
    //         import ('./components/Common/appDashboard'),
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },
    {
      path: "/ServerError",
      name: "ServerError",
      props: true,
      component: () => import("./components/Common/500"),
    },
    {
      path: "*",
      name: "404PageNotFound",
      props: true,
      meta: {
        requiresAuth: false,
      },
      component: () => import("./components/Common/404"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (
    to.matched.some((route) => route.meta.requireAuth == true) &&
    !store.state.isLoggedIn
  ) {
    next({ name: "LoginPage", params: { lastPage: from } });
    return;
  }
  // if (store.state.isLoggedIn) {
  //   axios({
  //     method: "GET",
  //     url: "/token/authenticate",
  //     headers: {
  //       token: localStorage.getItem("token"),
  //     },
  //   })
  //     .then((response) => {
  //       if (!response.data.status) {
  //         store.commit("sessionOut", true);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // }
  if (store.state.isLoggedIn) {
    axios({
      method: "GET",
      url: "/token/authenticate",
      headers: {
        token: localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (!response.data.status) {
          // Try to refresh token using refreshToken from cookie
          const refreshToken = Cookies.get('refreshToken');
          if (refreshToken) {
            axios({
              method: "POST",
              url: "/refresh-token",
              data: { refreshToken }
            })
              .then((refreshResponse) => {
                if (refreshResponse.data && refreshResponse.data.token) {
                  // Set new token in localStorage
                  localStorage.setItem("token", refreshResponse.data.token);
                  store.commit("loginUser", refreshResponse.data.token);
                  // If new refreshToken is provided, update it in the cookie
                  if (refreshResponse.data.refreshToken) {
                    Cookies.set('refreshToken', refreshResponse.data.refreshToken, { secure: true, sameSite: 'strict' });
                  }
                  next(); // Continue navigation
                } else {
                  store.commit("sessionOut");
                }
              })
              .catch(() => {
                store.commit("sessionOut");
              });
            return; // Prevent further navigation until refresh completes
          } else {
            store.commit("sessionOut");
          }
        } else {
          next();
        }
      })
      .catch((err) => {
        console.error(err);
        store.commit("sessionOut");
      });
    return; // Prevent next() from being called twice
  }

  // if (to.name == "LoginPage" && store.state.isLoggedIn) {
  //   const userType = getUserType();
  //   console.log("User Type:", userType);

  //   if (userType == "admin") {
  //     console.log("admin");
  //     next({ name: "DashboardPage" });
  //   } else if (userType == "user") {
  //     console.log("user");
  //     next({ name: "NatureCamps" });
  //   }
  //   else if (userType == "clerk") {
  //     console.log("user");
  //     next({ name: "ClerkDashboard" });
  //   }
  //   else if (userType == "superint") {
  //     console.log("user");
  //     next({ name: "SuperintedentDashboard" });
  //   } else if (userType == "adminsuperint") {
  //     console.log("user");
  //     next({ name: "CwwministerialDashboard" });
  //   } else if (userType == "adminclerk") {
  //     console.log("user");
  //     next({ name: "cwwclerkdashboard" });
  //   } else {
  //     next({ name: "divisiondashboard" });
  //     console.log("division");
  //   }
  //   return;
  // }
  if (to.name === 'LoginPage' && store.state.isLoggedIn) {
    redirectToDashboard();
    return;
  }
  if (to.matched.some(route => route.meta.requireAuth)) {
    const userType = getUserType();
    const isAuthorized = to.matched.every(route => {
      if (!route.meta.roles) return true;
      if (userType === 'superadmin' && route.meta.roles.includes('admin')) return true;
      return route.meta.roles.includes(userType);
    });

    if (!isAuthorized) {
      next({ name: '404PageNotFound' });
      return;
    }
  }

  next();
});

function getUserType() {
  const uType = localStorage.getItem('uType');
  console.log('uType:', uType);
  if (uType === '779') {
    return 'superadmin';
  } else if (uType === '777') {
    return 'admin';
  } else if (uType === '772') {
    return 'user';
  } else if (uType === '7741') {
    return 'clerk';
  } else if (uType === '7742') {
    return 'superint';
  } else if (uType === '7771') {
    return 'adminclerk';
  } else if (uType === '7772') {
    return 'adminsuperint';
  } else if (uType === '7773') {
    return 'dcf';
  } else {
    return 'division';
  }
}

function redirectToDashboard() {
  const userType = getUserType();
  console.log('User Type:', userType);

  if (userType === 'admin' || userType === 'superadmin') {
    console.log('admin');
    router.push({ name: 'DashboardPage' });
  } else if (userType === 'user') {
    console.log('user');
    router.push({ name: 'NatureCamps' });
  } else if (userType === 'clerk') {
    console.log('user');
    router.push({ name: 'ClerkDashboard' });
  } else if (userType === 'superint') {
    console.log('user');
    router.push({ name: 'SuperintedentDashboard' });
  } else if (userType === 'adminsuperint') {
    console.log('user');
    router.push({ name: 'CwwministerialDashboard' });
  } else if (userType === 'adminclerk') {
    console.log('user');
    router.push({ name: 'cwwclerkdashboard' });
  } else if (userType === 'dcf') {
    router.push({ name: 'DcfDashboard' });
  } else {
    router.push({ name: 'divisiondashboard' });
    console.log('division');
  }
}


export default router